import { fetchWithErrorHandling, buildPostOptions } from "../FetchUtils";
import { useAuthUser } from "react-auth-kit";
import { getRegistryURL } from "../registry/Registry";

export const reloadTokens = (accessToken: string) => {
  return fetchWithErrorHandling(`${getRegistryURL()}/v1/system/reload-tokens`, buildPostOptions(accessToken, {}));
};

export const resetEnvironment = (accessToken: string, baseURL: string) => {
  return fetchWithErrorHandling(baseURL + "v1/system/reset-env", buildPostOptions(accessToken, {}));
};

export const clearStaticDataCache = (accessToken: string, baseURL: string) => {
  return fetchWithErrorHandling(`${baseURL}v1/system/clear-sd-cache`, buildPostOptions(accessToken, {}));
};

export const useSystemService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;

  return {
    reloadTokens: () => reloadTokens(accessToken),
    resetEnvironment: (baseURL: string) => resetEnvironment(accessToken, baseURL),
    clearStaticDataCache: (baseURL: string) => clearStaticDataCache(accessToken, baseURL),
  };
};
